import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { useFetchSelectHotelTemplate } from "../api";
import { SelectHotelTemplateHeader } from "./header";
import { HotelTemplateList } from "./hotel-template-list";

type Props = {
	hotelID: string;
};

export const SelectHotelTemplate = memo(({ hotelID }: Props) => {
	const { data } = useFetchSelectHotelTemplate({ hotelID });

	if (!data || !data.hotelTemplateSettings.hotelTemplateTypeSelectable) {
		notifyUserEventInfo({
			title: "ホテルテンプレートの選択はできません",
		});

		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<div className="mx-auto my-12 w-full max-w-[1024px] px-4 md:px-10">
			<div className="space-y-8">
				<SelectHotelTemplateHeader hotelID={hotelID} />
				<HotelTemplateList hotelID={hotelID} />
			</div>
		</div>
	);
});

SelectHotelTemplate.displayName = "SelectHotelTemplate";
